import { deleteAdditionalImageService } from "../infrastructure/services/deleteAdditionalImageService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteAdditionalImage = {
    async execute(campaignName: string, numImage: number): Promise<void> {
        await deleteAdditionalImageService.execute(await tokenValidation.execute(), campaignName, numImage);
    },
};